import { registerModal } from 'features/Modal/ModalRegistry'
import CasesCreateTroubleTicket from './CasesCreateTroubleTicket.container'
import { showModal } from 'features/Modal/Modal.actions'

export const modalType = 'CASES_CREATE_TROUBLE_TICKET'
registerModal(modalType, CasesCreateTroubleTicket)
export default modalProps =>
  showModal({
    modalType,
    modalProps,
    modalOptions: {},
  })



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Cases/CasesCreateTroubleTicket/CasesCreateTroubleTicket.action.js